module.exports = __webpack_public_path__ + "static/media/biker.dc3ea07a.png";